import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'


import '../App.css'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthContext } from '@/auth'

export type MyRouterContext = {
  auth: AuthContext

  queryClient: QueryClient
}


export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <Outlet />
  ),
})
